import { useEffect, useState, useRef } from 'react';
import { useAppContext } from "../context/AppContext";
import { quizData } from "../data/quizData";
import Iframe from "./Iframe";

const iframeUrl = `https://www.syngenta-lg.com/l/62082/2022-01-04/3t72g7w`;


const QuizModule = ({data}) => {
    const { 
        quizAnswers,
        showResults,
        setActiveIdx,
        setShowResults 
    } = useAppContext();

    const handleSubmit = (ev) => {
        ev.preventDefault();
        setShowResults(true);
        window.scrollTo(0, 0);
    }

    const list = useRef(null);
    const [ wrongAnswerCount, setWrongAnswerCount ] = useState(0);

    useEffect(() => {
        if (showResults) {
            setWrongAnswerCount(list.current.getElementsByTagName("li").length)
        }
    }, [showResults])
    
    

  return (
    <div className="quiz-wrapper">
      {!showResults ? (
        <>
          <div dangerouslySetInnerHTML={{ __html: data.title }} />
          <div dangerouslySetInnerHTML={{ __html: data.content }} />
          <ol>
            {quizData.questions.map((question, idx) => (
              <Question key={idx + 1} question={question} qIndex={idx + 1} />
            ))}
          </ol>

          <button
            onClick={handleSubmit}
            disabled={
              quizAnswers && Object.keys(quizAnswers).length === 10
                ? false
                : true
            }
          >
            Submit
          </button>
        </>
      ) : (
        <>
          <h2>
            Thank you, your quiz results have been successfully submitted.
          </h2>
          <div className="result-total">
            <p>
              You answered{" "}
              <span className="bold">
                {Object.keys(quizAnswers).length - wrongAnswerCount}
              </span>{" "}
              of <span className="bold">{Object.keys(quizAnswers).length}</span>{" "}
              questions correctly.
            </p>
          </div>
          {wrongAnswerCount > 0 && (
            <p style={{ fontWeight: `bold` }}>
              Please review your incorrect answers below:
            </p>
          )}

          <ol ref={list}>
            {quizAnswers &&
              showResults &&
              Object.keys(quizAnswers).map((ans, idx) => {
                let result;
                if (!quizAnswers[ans].isCorrect) {
                  result = (
                    <li className="wrong-answers" key={idx}>
                      <p>{quizAnswers[ans].question}</p>
                      <div className="wrong-answers-wrapper">
                        <p>You answered: {quizAnswers[ans].selected}</p>
                        <p>
                          The correct answer is:{" "}
                          {quizAnswers[ans].correctAnswer}
                        </p>
                      </div>
                    </li>
                  );
                }
                return result;
              })}
          </ol>

          <Iframe url={iframeUrl} />

          <div className="button-nav final">
            <div className="button-wrapper">
              <button
                onClick={() => {
                  setShowResults(false);
                  setActiveIdx(0);
                  window.scrollTo(0, 0);
                }}
              >
                &#60; Back to Learning Module
              </button>
              <button onClick={(ev) => {
                  ev.preventDefault();
                  window.location.href = "https://www.greencastonline.com/postiva";
                }
              }>Exit Module &#62;</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const Question = ({ question, qIndex }) => {

    const { quizAnswers, setQuizAnswers } = useAppContext();
    const [ isSelected, setIsSelected ] = useState(false);

    const handleChange = (ev) => {
      const { name, value } = ev.target;
      setIsSelected(value);
      updateAnswers(name, value);
    };

    const updateAnswers = (name, value) => {
        let obj = {
            question: question.question,
          selected: value,
          correctAnswer:
            quizData.questions[name - 1].answers[question.correctAnswer - 1],
          isCorrect:
            value ===
            quizData.questions[name - 1].answers[question.correctAnswer - 1],
        };
        setQuizAnswers({...quizAnswers, [name]: obj});
    };
  return (
    <li className="question-item">
      {question.question}
      <fieldset>
        {question.answers.map((answer, idx) => (
          <AnswerOption
            key={answer}
            answer={answer}
            idx={idx + 1}
            qName={qIndex}
            handleChange={handleChange}
            selected={ isSelected === answer }
          />
        ))}
      </fieldset>
    </li>
  );
};

const AnswerOption = ({ answer, qName, handleChange, selected }) => {
    
  return (
    <div>
      <label>
        <input
          type="radio"
          value={answer}
          name={qName}
          onChange={ handleChange }
          checked={ selected }
        />{" "}
        {answer}
      </label>
    </div>
  );
};

export default QuizModule;
